import { defineAsyncComponent } from 'vue'

export const ModalAdDisabled = defineAsyncComponent(() => import('../ModalAdDisabled/ModalAdDisabled.vue'))
